class GoogleKubernetesAuthProvider {
  authProvider;
  constructor(authProvider) {
    this.authProvider = authProvider;
  }
  async decorateRequestBodyForAuth(requestBody) {
    const googleAuthToken = (await this.getCredentials()).token;
    if ("auth" in requestBody) {
      requestBody.auth.google = googleAuthToken;
    } else {
      requestBody.auth = { google: googleAuthToken };
    }
    return requestBody;
  }
  async getCredentials() {
    return {
      token: await this.authProvider.getAccessToken(
        "https://www.googleapis.com/auth/cloud-platform.read-only"
      )
    };
  }
}

export { GoogleKubernetesAuthProvider };
//# sourceMappingURL=GoogleKubernetesAuthProvider.esm.js.map
